<template>
    <button class="test-drive-btn" @click.prevent="$emit('click')">
        <img 
         class="miniature"
         v-if="miniature"
         :src="miniature" 
         alt=""
         >
        <VideoIcon v-if="isShowVideoIcon"/>
        <span>
          {{label}}
        </span>
    </button>
</template>

<script>
    import VideoIcon from "../components/svg/Video";
    export default {
        components:{
            VideoIcon
        },
        props: {
            label: {
                type: String,
                default: 'Horfa á reynsluakstur'
            },
            miniature: {
                type:String,
                default: ''
            },
            videoUrl:{
                type: String,
                default:''
            },
            isShowVideoIcon: {
                type: Boolean,
                default: false
            }
        },
        methods: {
        }
    }
</script>

<style>

</style>